<template>
  <div>正在登录...</div>
</template>

<script>
import { useRouter } from "vue-router";
import request from "@/api/request";
import tokenHelper from "@/helpers/token_helper";
import userHelper from "@/helpers/user_helper";

let router;

export default {
  setup() {
    router = useRouter();
      singnIn(router.currentRoute.value.query.code);
    return { singnIn, router };
  },
};

function singnIn(code) {
  request
    .getToken({
      type: "WechatWeb",
      info: { code: code },
    })
    .then((res) => {
      let data = res.data;
      //新用户去绑定
      if (JSON.stringify(data.user) == "{}") {
        router.replace("/auths/sign_in/" + data.oauth_id);
      } else {
        let user = data.user;
        tokenHelper.storeTokens(user.token);
        userHelper.storeUserinfo(user);
        router.replace(userHelper.readRouterSession())
      }
    })
}
</script>

<style scoped>
</style>